import moment from 'moment';

export default {
    methods: {
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        validMobileNumber(phone){
            if(phone.length > 15){
                return false;
            }
            return this.isNumeric(phone);
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
              evt.preventDefault();
            } else {
              return true;
            }
        },

        arraysEqual(a, b) {
            if (a === b) return true;
            if (a.length !== b.length) return false;
          
            for (var i = 0; i < a.length; ++i) {
              if (a[i] !== b[i]) return false;
            }
            return true;
        },

        onlyAlpha(str) {
          // const rx = !/^[a-zA-Z]*$/;
          if(str.trim() == '') return false;
          
          return /^[a-zA-Z\s]*$/.test(str);
        },

        formatDate(date, format = 'YYYY-MM-DD') {
            const d =  moment(date).format(format);
            if(d == 'Invalid date'){
              return ''
            }
            return d
        },

        limitDecimal(number, limitTo=5) {
          // console.log('limit')
          return ( !number || Number.isInteger(number))? number : (number).toFixed(limitTo)
        }
    }
}